/**
 * Plan-your-visit template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import ThemeBusinessMap from './lib/partials/ThemeBusinessMap';
import ThemeLogoMarquee from './lib/partials/ThemeLogoMarquee';
import ThemeTextStackAndCarousel from './lib/partials/ThemeTextStackAndCarousel';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Plan-your-visit';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.log(`${NAME} > loaded`);
	initThemeBusinessMap();
	initThemeLogoMarquees();
	initThemeTextStackAndCarousel();
	initVideo();
}

/**
 * initThemeBusinessMap - Initialize the ThemeBusinessMap
 **/
const initThemeBusinessMap = () => {
	Logger.info(`${NAME} > initThemeBusinessMap`);

	const dom = document.querySelector(`[data-theme-business-map]`);
	if (!dom) return;

	const themeBusinessMap = new ThemeBusinessMap(dom);
	themeBusinessMap.init();
}


/**
 * initThemeLogoMarquees - Initialize the theme logo marquee
 */
const initThemeLogoMarquees = () => {
	Logger.info(`${NAME} > initThemeLogoMarquees`);
	const themeLogoMarquees = document.querySelectorAll('[data-theme-logo-marquee]');
	if (!themeLogoMarquees) return;
	themeLogoMarquees.forEach(themeLogoMarquee => {
		const el = new ThemeLogoMarquee(themeLogoMarquee);
		el.init();
	});
}

/**
 * initThemeTextStackAndCarousel - Initialize the theme text stack and carousel
 */
const initThemeTextStackAndCarousel = () => {
	Logger.info(`${NAME} > initThemeTextStackAndCarousel`);

	const themeTextStackAndCarouselDom = document.querySelector('[data-theme-text-stack-and-carousel]');
	if (!themeTextStackAndCarouselDom) return;
	const themeTextStackAndCarousel = new ThemeTextStackAndCarousel(themeTextStackAndCarouselDom);
	themeTextStackAndCarousel.init();
}

/**
 * initVideo - Initialize the video
 */
const initVideo = () => {
	Logger.info(`${NAME} > initVideo`);
	const themeVideoPlayButton = document.querySelector('[data-theme-video-play-button]');
	const themeVideoElement = document.querySelector('[data-theme-video-element]');
	if (!themeVideoPlayButton || !themeVideoElement) return;
	themeVideoPlayButton.addEventListener('click', () => {
		if (themeVideoElement.paused) {
			themeVideoElement.play();
		} else {
			themeVideoElement.pause();
		}
	});

	themeVideoElement.addEventListener('play', () => {
		themeVideoPlayButton.classList.add('plan-video__video-play--hidden');
	});

	themeVideoElement.addEventListener('pause', () => {
		themeVideoPlayButton.classList.remove('plan-video__video-play--hidden');
	});
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
